module.exports = __webpack_public_path__ + "img/Paula Barreiro.209ea60e.jpg";